import { createApp, h, resolveComponent } from 'vue';
import { vMaska } from 'maska';
import { handleSplashScreen } from 'freedom-shared';
import {
  directives,
  controllerModel,
  BottomSheetPlugin,
  ModalPlugin,
} from 'shared';

import { BloomreachPromoAlert, NpsSurveyTrigger } from './ui';
import { withProviders } from './providers';
import '@/assets/css/main.css';

const App = {
  name: 'FreedomAviaApp',
  render: () => [
    h(resolveComponent('router-view')),
    h(BloomreachPromoAlert),
    h(NpsSurveyTrigger),
  ],
};

const app = createApp(App);

withProviders(app);

app
  .use(ModalPlugin, {
    controllerInjectionKey:
      controllerModel.injectionSymbols.MODAL_CONTROLLER_SYMBOL,
  })
  .use(BottomSheetPlugin, {
    controllerInjectionKey:
      controllerModel.injectionSymbols.BOTTOM_SHEET_CONTROLLER_SYMBOL,
  })
  .directive('maska', vMaska)
  .directive('price', directives.vPrice)
  .mount('#app');

handleSplashScreen();
